<template>
  <div class="company-clients">
    <!-- callback details -->
    <div class="company-clients-content">
      <div class="company-clients-content-header">
        <TText large value="CALLBACK.details" />
      </div>
      <div class="company-clients-content-body">

        <TextArea
          :value="selected_client.base_uri + selected_callback.callback_uri + selected_client.query_string" 
          label="CALLBACK" 
          background_color="#121212"
          foreground_color="#fff"
          :is_disabled="true"
        />

        <!-- <DisableableInputField label="CALLBACK" :value="selected_client.base_uri + selected_callback.callback_uri"
          background_color="#121212" :is_disabled="true" /> -->
        <DisableableInputField label="CALLBACK.uri" :value="selected_callback.callback_uri" background_color="#121212"
          @change="updateCallback({ callback_uri: $event })" />
        <DropDownOutlinedFlat label="CALLBACK.method"
          :options="[{ text: 'POST', value: 'POST', disabled: false }, { text: 'PUT', value: 'PUT', disabled: false }, { text: 'DELETE', value: 'DELETE', disabled: false }]"
          :value="selected_callback.method" :is_disabled="false" style="width: 100%;" background_color="#121212"
          foreground_color="#fff" @change="updateCallback({ callback_http_method: $event })" />
        <DropDownOutlinedFlat label="USER.action"
          :options="[{ text: 'CREATE', value: 'POST', disabled: false }, { text: 'UPDATE', value: 'PUT', disabled: false }, { text: 'DELETE', value: 'DELETE', disabled: false }]"
          :value="selected_callback.user_action" :is_disabled="false" style="width: 100%;" background_color="#121212"
          foreground_color="#fff" @change="updateCallback({ takt_http_method: $event })" />
        <DropDownOutlinedFlat label="USER.target" :options="user_targets" :value="selected_callback.user_target"
          :is_disabled="false" style="width: 100%;" background_color="#121212" foreground_color="#fff"
          @change="updateCallback({ takt_entity: $event })" />
        <ButtonOutlined v-if="is_callback_create" class="mt-5" @buttonClicked="create()" style="width: 100%;" text_size="12"
          value="Create callback" />
        <ButtonOutlined v-if="!is_callback_create" class="mt-5" @buttonClicked="deleteCB()" style="width: 100%;" text_size="12"
          value="Delete callback" />

      </div>
    </div>
  </div>
</template>

<script>

import { CompanyClientsMixin } from '@/mixins/CompanyClients.mixin.js'
import { mapActions } from 'vuex';
export default {
  name: 'CompanyClientsCallbacksDetails',
  components: {

  },
  mixins: [CompanyClientsMixin],
  data: function () {
    return {
    }
  },
  created() {

  },
  computed: {


  },
  methods: {
    ...mapActions('Client', [
      'setCallbackValue',
    ]),
    updateCallback(update) {
      if (this.is_callback_create) {
        this.setCallbackValue(update);
      } else {
        this.updateUObject({
          url: [
            { clients: this.client_id },
            { callbacks: this.callback_id },
          ],
          update: update
        })
      }
    },
    create(){
      this.createUObject({
        url: [
          { clients: this.client_id },
          { callbacks: '' },
          { showWithEntitiesNormalized: '' }
        ],
        u_object: this.selected_callback
      }).then(() => {
        this.$router.push({ name: 'CompanyClientsCallbacks' });
      })
    },
    deleteCB(){
      this.deleteUObject({
        url: [
          { clients: this.client_id },
          { callbacks: this.callback_id }
        ]
      }).then(() => {
        this.$router.push({ name: 'CompanyClientsCallbacks' });
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.company-clients {
  position: relative;
  width: 100%;
  display: flex;
  overflow: hidden;
  // padding: 5px;
}

.company-clients-content-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.company-clients-seperator {
  background-color: #fff !important;
  border-color: #fff !important;
  // background-color: #000!important;
  // border-color: #000!important;
  position: relative;
  display: flex;
  flex-shrink: 0;
  height: calc(100% - 10px);
  top: 5px;
  width: 1px;
  opacity: .2;
}

.company-clients-content {
  display: flex;
  flex-direction: column;
  // background-color: blue;
  padding-left: 10px;
  padding-right: 10px;
  width: 400px;
}

.company-client-content-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
}

.company-clients-content-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  grid-gap: 10px;
  max-width: 400px !important;
}
</style>
